import { forwardRef } from 'react';
import type { LinkProps } from 'react-router';
import { Link, useLocation } from 'react-router';

import type { NavAction } from './NavAction';
import { resolveNavAction } from './resolveNavAction';

export interface LinkNavActionProps extends Omit<
	LinkProps,
	'to' | 'state' | 'replace'
> {
	to: NavAction;
}

/**
 * Exactly the same as React Router's {@link Link} except the `to` prop can be a
 * {@link NavAction}.
 *
 * @see {@link NavAction}'s doc comment for example usage.
 */
export const LinkNavAction = forwardRef<HTMLAnchorElement, LinkNavActionProps>(
	function LinkNavActionRender({ to: navAction, ...other }, forwardedRef) {
		return (
			<Link
				{...other}
				ref={forwardedRef}
				{...resolveNavAction(useLocation(), navAction)}
			/>
		);
	}
);
